import { widgetWrapperStyles } from "@store/theme/common/mixins";
import styled from "styled-components";

const WidgetWrapper = styled.div`
    ${widgetWrapperStyles()}
`;

export default WidgetWrapper;
